module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/coffee-icon-9f91c6a912e3eee484ee5750d5674896.png";